import { KeyboardEvent } from 'react';
import { DatePicker } from '@mui/x-date-pickers-pro';
import {
  MAX_CUSTOM_FIELD_DATE,
  MIN_CUSTOM_FIELD_DATE,
  isAcceptableCustomFieldDate
} from '../../../utils/customFieldTypes';

export interface CustomFieldDatePickerProps {
  value: Date | null;
  // Reports every day the picker reads, whole or not, with whether it is one worth keeping. Swallowing
  // the rest would leave a half-typed or out-of-range entry looking saved while the old value stood.
  onChange: (date: Date | null, acceptable: boolean) => void;
  disabled?: boolean;
  // Focus lands on whatever opened this editor unless it is claimed here.
  takeFocus?: boolean;
  onKeyDown?: (event: KeyboardEvent) => void;
  variant?: 'standard' | 'outlined';
}

export const CustomFieldDatePicker = ({
  value,
  onChange,
  disabled = false,
  takeFocus = false,
  onKeyDown,
  variant = 'outlined'
}: CustomFieldDatePickerProps) => {
  return (
    <DatePicker
      value={value ?? null}
      disabled={disabled}
      minDate={MIN_CUSTOM_FIELD_DATE}
      maxDate={MAX_CUSTOM_FIELD_DATE}
      onChange={(picked) => onChange(picked, isAcceptableCustomFieldDate(picked))}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          variant,
          // Through slotProps so the field selects its first section, which a bare focus() does not.
          autoFocus: takeFocus,
          onKeyDown,
          inputProps: { style: { fontSize: '0.875rem' } }
        }
      }}
    />
  );
};
